export default "__VITE_ASSET__$jLnLMrs__"